import { dashboardApi } from "@/api/dashboardApi";
import Breadcrumbs from "@/components/Breadcrumbs";
import Loading from "@/components/feedback/Loading";
import { Container, Divider } from "@mui/material";
import { Outlet, useParams } from "react-router-dom";

export default function DashboardLayout() {
    const { dashboardId } = useParams();
    const getDashboard = dashboardApi.endpoints.getDashboardById.useQuery({
        dashboardId,
    });
    const dashboardData = getDashboard.data?.data;
    const isLoading = getDashboard.isLoading;

    return (
        <>
            <Container>
                <Breadcrumbs
                    items={[
                        { label: "Dashboard Hub", to: "/dashboard-hub" },
                        { label: "view" },
                        { label: `#${dashboardId}` },
                    ]}
                />
            </Container>
            {isLoading ? <Loading /> : <Outlet context={{ dashboard: dashboardData }} />}
        </>
    );
}
